import { For, Match, ParentProps, Show, Switch, createContext, createEffect, createSignal } from 'solid-js'
import { requireContext } from 'common'
import { NyrsetupDefinitiontilesContext } from './NyrsetupDefinitiontilesContext'
import styles from './sis-nyrsetup-definitiontiles.module.css'
import { Loader, ST, STComponentWrapperProps } from 'st-app';
import { createStore } from 'solid-js/store';
import { NyrSetupDefinition, NyrSetupDefinitionTilesData } from '../../api';
import NyrSetupDefinitionTilesApi from '../../api/sis-nyrsetup-definitiontiles';

const NyrsetupDefinitiontilesContextJsx = createContext<NyrsetupDefinitiontilesContext>();
export const requireNyrsetupDefinitiontilesContext = () => {
    return requireContext(NyrsetupDefinitiontilesContextJsx);
}

export class NyrsetupDefinitiontilesProps extends STComponentWrapperProps { }

export default function NyrsetupDefinitiontiles(props: ParentProps<NyrsetupDefinitiontilesProps>) {
    const context = new NyrsetupDefinitiontilesContext();

    return (
        <NyrsetupDefinitiontilesContextJsx.Provider value={context}>
            <NyrSetupDefinitionTilesContainer {...props} />
        </NyrsetupDefinitiontilesContextJsx.Provider>
    )
}

function NyrSetupDefinitionTilesContainer(props: ParentProps<NyrsetupDefinitiontilesProps>) {
    const [jsonData, setJsonData] = createSignal<NyrSetupDefinitionTilesData | undefined>(undefined);

    createEffect(() => {
        if (props.value) {
            NyrSetupDefinitionTilesApi.GetJsonDataObject(props.value).then(res => { setJsonData(res); })
        }
    });

    return (
        <Switch fallback={<div class={styles.spinnerHolder}><Loader size='large'/></div>}>
            <Match when={jsonData() != undefined && jsonData()?.definitions != null}>
                <div class={styles['definition-tiles-container']}>
                    <Show when={jsonData()?.definitions.length ?? 0 > 0}>
                        <For each={jsonData()?.definitions}>
                            {(definition) => (
                                <NyrSetupDefinitionTile definition={definition} isDefault={false} />
                            )}
                        </For>
                    </Show>
                    <NyrSetupDefinitionTile definition={undefined} isDefault={true} />
                </div>
            </Match>
        </Switch>
    );
}

function NyrSetupDefinitionTile(props: { definition: NyrSetupDefinition | undefined, isDefault: boolean }) {
    return <button class={styles['definition-tiles']} onclick={() => { handleButtonClick(props.definition?.nyrSetupDefGU, props.isDefault) }}>
        <Show when={props.isDefault == false} fallback={<img src="Images/ST_VIEW/ADDSECTION.svg" />}>
            <span>{props.definition?.setupDefName}</span>
            <span>{props.definition?.extension}</span>
            <span>{props.definition?.yearToYearString}</span>
        </Show>
    </button>
}

function handleButtonClick(defGU : string | undefined, isDefault: boolean) {    
    if (isDefault) {
        ST.OpenAddViewInDialog("396B31B2-1787-44A1-A1E2-B638BA77F9EF", null, null , null, null);
    } else {
        ST.OpenViewWindow('78F2FA39-3955-4F3A-A8CF-2EE64A2D7174', null, defGU, null);
    }
    
}

NyrsetupDefinitiontiles.defaultProps = new NyrsetupDefinitiontilesProps();